import React, { useState, useEffect } from 'react'
import MultiSelect from '@components/Form/MultiSelect'
import api from '@services/api'
import * as Utils from '@services/utils'

export default ({
    filter,
    selectedFilters,
    updateFilters,
    collection,
    required,
    optionsRequired,
    optionsMsg,
}) => {
    const [options, setOptions] = useState([])
    const [inputText, setInputText] = useState('')

    useEffect(() => {
        api.getFilterOptions(
            collection,
            filter.property,
            filter.subProperty,
            inputText
        ).subscribe((res) => {
            //console.log('filter options res = ', res)
            // setOptions(res.data)
            if (res.data.length > 0) {
                setOptions(res.data)
            } else {
                if (optionsRequired) {
                    setOptions([
                        { label: inputText + optionsMsg, value: inputText },
                    ])
                }
            }
        })
        // }
    }, [inputText])

    const filterName =
        filter.property + (filter.subProperty ? ':' + filter.subProperty : '')

    return (
        <MultiSelect
            required={required}
            label={filter.label}
            placeholder={filter.label}
            value={
                selectedFilters[filterName]
                    ? selectedFilters[filterName].map((option) => option)
                    : []
            }
            onChange={(selected) => updateFilters(filterName, selected)}
            onInputChange={(text) =>
                Utils.onControlledChange(text, 0, setInputText)
            }
            options={(options || []).map((option) => {
                if (typeof option === 'object') {
                    return option
                } else if (typeof option === 'string') {
                    return { label: option, value: option }
                }
            })}
        />
    )
}
